import React from "react";

import Carousel from "./coreCarousel";

export default class DemoCarousel extends React.Component{
  render() {
    const { props } = this;
    const { children, options, galleryButton, className, value, onChange, length } = props;

    return (
      <Carousel
        onChange={onChange}
        value={value}
        className={className}
        options={options}
        length={length}
        galleryButton={galleryButton}
      >
        {children}
      </Carousel>
    );
  }
}
